import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Dropdown, Icon, Button, message } from 'antd';
import { inject, observer } from 'mobx-react';
import { Link, withRouter } from 'react-router-dom';

const logo = require('./../images/tubitak_logo.svg');

const ProfileDroprown = inject('authStore')(
  withRouter(
    observer(({ authStore }) => {
      const onClick = ({ key }) => {
        switch (key) {
          case 'logout':
            message.success('You have successfully logged out, redirecting to home page...', 1.5);
            setTimeout(() => authStore.logout(), 1500);
            break;
          default:
            break;
        }
      };
      return (
        <Menu onClick={onClick}>
          <Menu.Item key="logout">
            <Icon type="logout" />
            Log Out
          </Menu.Item>
        </Menu>
      );
    })
  )
);

const HeaderProfile = ({ self }) => {
  if (!self) {
    return (
      <div className="header__profile">
        <Link to="/login">
          <Button ghost icon="login">
            Login
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="header__profile">
      <Dropdown overlay={<ProfileDroprown />} trigger={['click']}>
        <Button style={{ marginLeft: 8 }}>
          <Icon type="user" /> {self.displayName} <Icon type="down" />
        </Button>
      </Dropdown>
    </div>
  );
};
HeaderProfile.propTypes = {
  self: PropTypes.object,
};
HeaderProfile.defaultProps = {
  self: null,
};

const Header = inject('commonStore', 'userStore')(
  observer(({ commonStore, userStore, children }) => (
    <div id="header" className="flex-row flex--aligned">
      <Button
        className="menu-toggle"
        style={{ marginRight: 6 }}
        icon={commonStore.isSidebarActive ? 'menu-fold' : 'menu-unfold'}
        onClick={() => commonStore.toggleSidebar()}
      />
      <Link to="/">
        <div className="app-header flex-row flex--aligned">
          {
            /*
              <img
                src={logo}
                style={{
                  width: 32,
                  filter: 'brightness(0.4) invert(1)'
                }}
                alt="ingv logo"
              />
            */
          }
          <span className="app-header__title">Interactive Tsunami Hazard Tool</span>
        </div>
      </Link>
      <div className="flex-spacer" />
      {children}
      <HeaderProfile self={userStore.self} />
    </div>
  ))
);

Header.propTypes = {
  children: PropTypes.array,
};

Header.defaultProps = {
  children: null,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js